/* Support for dual colors menu */

const initMenuColors = () => {
  const menuClipItems = document.querySelectorAll(".Header--clip-parent");

  const clipObjects = [];

  let highestTop = 10000;
  let lowestBottom = 0;

  menuClipItems.forEach((item) => {
    const clip = item.getBoundingClientRect();

    if (clip.top < highestTop) {
      highestTop = clip.top;
    }
    if (clip.bottom > lowestBottom) {
      lowestBottom = clip.bottom;
    }

    const obj = {
      top: clip.top,
      bottom: clip.bottom,
      clip: item.querySelector(".Header--clip"),
    };

    clipObjects.push(obj);
  });

  const menuClipSections = document.querySelectorAll(".Section--clip-menu");

  if(menuClipSections.length === 0) {
    return;
  }
  document.addEventListener("scroll", onScroll);
  onScroll();

  function onScroll(e) {
    let closest = menuClipSections[0];
    let closestDistance = 10000;
    menuClipSections.forEach((item) => {
      // get current section
      const section = item.getBoundingClientRect();

      const topDistance = Math.abs(section.top - lowestBottom);
      const bottomDistance = Math.abs(section.bottom - highestTop);
      const minDistance = Math.min(topDistance, bottomDistance);

      if (minDistance < closestDistance) {
        closest = item;
        closestDistance = minDistance;
      }
    });

    let section = closest.getBoundingClientRect();

    if (section.top < lowestBottom && section.bottom > highestTop) {
      clipObjects.forEach((obj) => {
        const height = obj.bottom - obj.top;

        const topClip = ((section.top - obj.top) / height) * 100;
        const bottomClip = ((obj.bottom - section.bottom) / height) * 100;

        const topClipped = Math.abs(topClip) < Math.abs(bottomClip);

        obj.clip.style.clipPath = topClipped
          ? `inset(${topClip}% 0 0 0)`
          : `inset(0 0 ${bottomClip}% 0)`;
      });
    }

    if (section.top > lowestBottom) {
      clipObjects.forEach((obj) => {
        obj.clip.style.clipPath = `inset(100% 0 0 0)`;
      });
    }

    if (section.bottom < highestTop) {
      clipObjects.forEach((obj) => {
        obj.clip.style.clipPath = `inset(0 0 100% 0)`;
      });
    }
  }
};

// initMenuColors();

const initMenuLogo = () => {
  const menu = document.querySelector(".Header");

  const hasNoCenterLogo = menu.classList.contains("Logo--hidden");

  if (hasNoCenterLogo) {
    return;
  }

  window.addEventListener("scroll", () => {
    if (window.scrollY > 100) {
      menu.classList.add("Logo--hidden");
    } else {
      menu.classList.remove("Logo--hidden");
    }
  });
};

// initMenuLogo();

const initMagaMenu = () => {
  const megaMenu = document.querySelector(".Header--mega-menu");

  if(!megaMenu) {
    return;
  }

  const menuItems = megaMenu.querySelectorAll(".MegaMenu--trees > .MegaMenu--item");

  const overlay = megaMenu.querySelector(".Overlay");

  menuItems.forEach((item) => {
    item.addEventListener("click", (e)=>{
      // click code
      if(e.target.closest(".MegaMenu--link") && !e.target.closest(".MegaMenu--link").closest(".MegaMenu--item").parentElement.closest(".MegaMenu--item")) {
        e.stopPropagation();
        e.preventDefault();

        closeAll(menuItems, item);
        item.classList.toggle("Open");
      }
      // hover code

      /*
      closeAll(menuItems, item);
      item.classList.add("Open");
      */
    });

    /*
    item.addEventListener("mouseleave", (e)=>{

        closeAll(menuItems, item);
        item.classList.remove("Open");
    });
    */
  });

  function closeAll(items, except = null){
    items.forEach((item) => {
      if(item === except) {
        return;
      }
      item.classList.remove("Open");
    });
  }

  document.addEventListener("click", (e)=>{

    if(e.target.closest(".MegaMenu--item")) {
      return;
    }

    closeAll(menuItems);
  });
};

initMagaMenu();

function initMobileMenu() {
  const triggers = document.querySelectorAll('[data-event="toggle-mobile-menu"]');
  const mobileMenu = document.querySelector(".MobileMenu");

  const mainList = document.querySelector(".MobileMenu--list");
  const sublistItems = document.querySelectorAll(".MobileMenu--has-sublist");
  const sublists = document.querySelectorAll(".MobileMenu--sublist");
  const allLastlists = document.querySelectorAll(".MobileMenu--lastlist");

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();

      mobileMenu.classList.toggle("Open");

      allLastlists.forEach((list) => {
        list.classList.remove("Open");
      });

      sublists.forEach((sublist) => {
        sublist.classList.remove("Open");
      });
    });
  });

  

  sublistItems.forEach((item, i) => {

    item.addEventListener("click", (e) => {
      e.preventDefault();

      sublists[i].classList.add("Open");
    });
  });


  sublists.forEach((sublist) => {
    const closeButton = sublist.querySelector(".MobileMenu--sublist-close");
    closeButton.addEventListener("click", (e) => {
      e.preventDefault();

      allLastlists.forEach((list) => {
        list.classList.remove("Open");
      });
      sublist.classList.remove("Open");
    });

    const lastListItems = sublist.querySelectorAll(".MobileMenu--list-item:has(.MobileMenu--has-lastlist)");

    lastListItems.forEach((item) => {
      const lastlist = item.querySelector(".MobileMenu--lastlist");
      const button = item.querySelector(".MobileMenu--has-lastlist");

      lastlist.style.setProperty("--lastlist-height", `${lastlist.scrollHeight}px`);

      window.addEventListener("resize", () => {
        lastlist.style.setProperty("--lastlist-height", `${lastlist.scrollHeight}px`);
      });

      button.addEventListener("click", (e) => {
        e.preventDefault();

        allLastlists.forEach((list) => {
          if (lastlist !== list) {
            list.classList.remove("Open");
          }
        });
        lastlist.classList.toggle("Open");
        button.classList.toggle("Open");
      });
    });
  });

  
}

initMobileMenu();
